// extracted by mini-css-extract-plugin
export default {"addToCartControl":"FY-z","giftCard":"GY-z","btnContainer":"HY-z","cartButton":"IY-z","disabled":"JY-z"};